import { render, staticRenderFns } from "./stat.vue?vue&type=template&id=cfb0c43e&scoped=true&"
import script from "./stat.vue?vue&type=script&lang=ts&"
export * from "./stat.vue?vue&type=script&lang=ts&"
import style0 from "./stat.vue?vue&type=style&index=0&id=cfb0c43e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb0c43e",
  null
  
)

export default component.exports